import type { Strings } from "./en";

/** Русский. Без длинных тире по правилам бренда. */
/** Russian plural forms: plural(3, "заявка", "заявки", "заявок"). */
function plural(n: number, one: string, few: string, many: string): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  if (a > 10 && a < 20) return many;
  if (b > 1 && b < 5) return few;
  if (b === 1) return one;
  return many;
}

export const ru: Strings = {
  nav: {
    how: "Как это работает",
    industries: "Отрасли",
    pricing: "Цены",
    faq: "Вопросы",
    signIn: "Войти",
    startFree: "Начать бесплатно",
    openApp: "Открыть OctoMail",
    language: "Язык",
  },
  landing: {
    hero: {
      eyebrow: "Ваш помощник для новых клиентов, всегда на связи",
      h1: "Каждый клиент получит ответ.",
      lead: "OctoMail читает каждое новое сообщение в вашей почте и Telegram, в течение минуты отвечает вашим тоном и на языке клиента и передаёт вам настоящих покупателей с уже собранными деталями.",
      ctaTrial: "Начать 7-дневный бесплатный период",
      ctaSee: "Посмотреть в деле",
      fine: "Без платы за подключение · Отмена в любой момент · Работает с Gmail и Telegram",
    },
    demo: {
      email: "Email",
      telegram: "Telegram",
      aria: "Пример диалога",
      replied: "OctoMail ответил меньше чем за минуту",
      qualified: "Целевая заявка",
      emailConvo: {
        name: "Джасур",
        tag: "Автомобиль",
        customer1: "Добрый день! Chevrolet Malibu 2021 года ещё в продаже? Можно посмотреть в выходные?",
        reply: "Здравствуйте, Джасур! Да, Malibu ещё в продаже. Время просмотра согласуем с вами: удобнее утро субботы или воскресенья?",
        customer2: "В субботу утром подойдёт.",
      },
      telegramConvo: {
        name: "Нигора",
        tag: "Ванная",
        customer1: "Здравствуйте! Сколько стоит ремонт ванной? Мы в Юнусабаде.",
        reply: "Здравствуйте, Нигора! Спасибо, что написали. Стоимость подскажем, когда уточним детали: какая примерно площадь ванной и когда хотите начать?",
        customer2: "Около 6 м². В следующем месяце.",
      },
    },
    does: {
      eyebrow: "Что он делает",
      title: "Что OctoMail делает для вас",
      items: [
        { title: "Читает каждое сообщение", body: "Email и Telegram, днём и ночью, в ту же секунду." },
        { title: "Отвечает в течение минуты", body: "Вашим тоном и на языке клиента: русском, узбекском, английском и других." },
        { title: "Собирает детали", body: "Уточняет адрес, сроки или бюджет, чтобы каждая заявка приходила готовой." },
        { title: "Передаёт вам важное", body: "Жалобы и текущие клиенты сразу попадают к вам вместе с уведомлением." },
      ],
    },
    day: {
      eyebrow: "Как это работает",
      title: "От первого сообщения до готовой заявки, пока вы работаете",
      steps: [
        { time: "9:41", title: "Клиент пишет", message: "Здравствуйте! Нужен ремонт кухни, мы в Чиланзаре.", note: "В Telegram, пока вы на объекте." },
        { time: "9:42", title: "OctoMail отвечает", message: "Здравствуйте, Дильноза! Когда хотите начать и какая примерно площадь кухни?", note: "По-русски, вашим тоном. Без цен и обещаний." },
        { time: "9:50", title: "Готовая заявка у вас", message: "", note: "Перезваниваете тем, кто стоит вашего времени." },
      ],
      lead: [
        { k: "Работа", v: "Ремонт кухни" },
        { k: "Район", v: "Чиланзар" },
        { k: "Начало", v: "В следующем месяце" },
      ],
      statusLabel: "Статус",
      status: "Целевая",
    },
    control: {
      eyebrow: "Контроль у вас",
      title: "Он работает на вас, а не вместо вас",
      items: [
        "Email: первый ответ вы одобряете сами, дальше OctoMail отвечает без вас.",
        "Telegram: вы выбираете, в каких чатах он отвечает.",
        "Как только вы отвечаете сами, OctoMail перестаёт отвечать в этом диалоге.",
        "Он никогда не называет цены, не даёт скидок и не обещает сроки. Жалобы и текущие клиенты сразу попадают к вам.",
      ],
    },
    industries: {
      eyebrow: "Под то, как к вам приходят клиенты",
      title: "Что бы вы ни продавали, выигрывает первый ответ.",
      sub: "Настоящие заявки, ответы вашими словами, автоматически. Вот как это выглядит в вашей сфере.",
      inbound: "Входящее",
      inYourVoice: "OctoMail · вашими словами",
      seeFor: (x: string) => `OctoMail для ${x} →`,
      items: {
        dealerships: {
          label: "Автосалоны",
          inbound: "Chevrolet Tracker 2021 ещё в наличии?",
          reply: "Здравствуйте, Джасур. Да, ещё в продаже. Договоримся о времени, когда вам удобно приехать посмотреть?",
          linkText: "автосалонов",
        },
        contractors: {
          label: "Строительство и ремонт",
          inbound: "Хотим переделать кухню, когда сможете приехать посмотреть?",
          reply: "Здравствуйте, Дильноза. С удовольствием приеду. Вам удобнее утром или после обеда, чтобы снять размеры?",
          linkText: "строителей",
        },
        dental: {
          label: "Стоматологии",
          inbound: "Принимаете новых пациентов? Нужна чистка и осмотр.",
          reply: "Здравствуйте, Сардор. Да, будем рады вас принять. Какие дни вам обычно удобны?",
          linkText: "стоматологий",
        },
        auto: {
          label: "Автосервисы",
          inbound: "Скрипят тормоза, сможете посмотреть на этой неделе?",
          reply: "Здравствуйте, Азиз. Конечно, посмотрим. Машина на ходу, и какой день вам удобнее?",
          linkText: "автосервисов",
        },
        rv: {
          label: "Дома на колёсах",
          inbound: "Прицеп Winnebago 2022 ещё продаётся?",
          reply: "Здравствуйте, Бекзод. Да, он ещё в наличии. Хотите приехать посмотреть?",
          linkText: "продавцов прицепов",
        },
        sales: {
          label: "Отделы продаж",
          inbound: "Выбираем инструмент для команды из 12 человек, расскажете подробнее?",
          reply: "Здравствуйте, Камола. С радостью покажу вам и команде. Когда удобно созвониться на пару минут?",
          linkText: "отделов продаж",
        },
      },
    },
    stats: {
      eyebrow: "Скорость приносит заказы",
      title: "Обычно выигрывает тот бизнес, который отвечает первым.",
      items: [
        { big: "21×", small: "выше шанс получить заказ, если ответить в течение 5 минут" },
        { big: "78%", small: "покупателей выбирают бизнес, который ответил первым" },
        { big: "< 1 мин", small: "чтобы OctoMail ответил на новую заявку, днём и ночью" },
      ],
      note: "Цифры по скорости ответа из отраслевых исследований (Lead Response Management / Harvard Business Review). Сейчас подключаем первые компании в Канаде, США и Узбекистане. Присоединяйтесь к первым.",
    },
    pricing: {
      eyebrow: "Цены",
      title: "Один простой тариф. Без сюрпризов.",
      sub: "Меньше, чем вы потеряете на одном упущенном заказе.",
      monthly: "Помесячно",
      annual: "За год · экономия 25%",
      planName: "OctoMail",
      planSub: "Всё, что нужно, чтобы не упустить ни одной заявки.",
      perMo: (code: string) => `/мес ${code}`,
      billedYearly: (annual: string, code: string) => `${annual} ${code} в год`,
      billedMonthly: (code: string) => `Оплата ежемесячно в ${code}`,
      switchNote: " · перейдите на год и получите 3 месяца бесплатно",
      factDay: (rate: string) => `Около ${rate} в день`,
      factAdmin: "Администратор на полставки: миллионы сумов в месяц",
      factPays: "Окупается одним заказом",
      features: [
        "Читает каждое новое письмо и сообщение в Telegram",
        "Отделяет настоящих покупателей от спама",
        "Отвечает вашим тоном на языке клиента",
        "Работает с Gmail и Telegram",
        "Все диалоги в одном месте",
      ],
      telegramNote: "Для подключения Telegram на бизнес-аккаунте нужен Telegram Premium.",
      cta: "Начать 7 дней бесплатно",
      fine: "7 дней бесплатно. Карта не списывается, пока вы не решите остаться.",
    },
    faq: {
      eyebrow: "Вопросы",
      title: "Хорошие вопросы, прямые ответы.",
      items: [
        { q: "Нужно ли хорошо разбираться в компьютерах?", a: "Нет. Вы один раз входите через Google, остальное OctoMail делает сам. Если умеете проверять почту, справитесь и с ним." },
        { q: "Как он отличает настоящий заказ от спама?", a: "OctoMail читает каждое письмо через то, что важно вам: кто пишет, что нужно, сроки, адрес. Настоящие заявки помечает, спам и просто интересующихся откладывает, так что с одного взгляда видно, с кем стоит продолжить." },
        { q: "А если клиент не указал бюджет или сроки?", a: "OctoMail помечает заявку как «нужны детали» и готовит дружелюбный ответ, в котором спрашивает только недостающее, чтобы разговор продолжался без вашего участия." },
        { q: "Он отвечает сам?", a: "Да, в этом и смысл. В почте OctoMail автоматически отвечает на новые заявки вашим тоном, после того как вы одобрите самый первый ответ. В Telegram он отвечает новым клиентам в разрешённых вами чатах сразу после подключения. Он никогда не называет цену и не обещает сроки, и его можно выключить в любой момент." },
        { q: "Клиенты поймут, что это автоматика?", a: "Нет. Ответы тёплые, написаны простым языком и вашим тоном, никаких роботизированных шаблонов. В почте первый ответ вы видите и одобряете до того, как что-либо будет отправлено." },
        { q: "Работает ли с моей почтой?", a: "Сейчас OctoMail работает с Gmail и Google Workspace. У вас Outlook или другой сервис? Напишите на support@octoaiverse.com, и мы сообщим, как только добавим поддержку." },
        { q: "Моя почта в безопасности?", a: "Да. Мы подключаемся через официальный защищённый вход Google. Ваш пароль никогда не попадает в OctoMail, а письма никому не передаются." },
        { q: "Сколько это стоит?", a: "99 $ в месяц (USD) или дешевле при годовой оплате. Каждый аккаунт начинается с 7 бесплатных дней, карта не списывается, пока вы не решите остаться." },
        { q: "А если я захочу отменить?", a: "Отмените в любой момент в два клика или напишите на support@octoaiverse.com, и мы всё сделаем. Без препятствий." },
        { q: "Работает ли с Telegram?", a: "Да. Вы один раз подключаете OctoMail к своему аккаунту Telegram: в настройках Telegram для бизнеса, в разделе Чат-боты. Клиенты по-прежнему пишут вам, а не боту, а OctoMail отвечает в тех чатах, которые вы разрешите. Для этого на бизнес-аккаунте нужен Telegram Premium." },
        { q: "Что происходит с сообщениями моих клиентов?", a: "OctoMail читает их только для того, чтобы понять запрос и написать ответ; для этого текст обрабатывается Google Gemini. Диалоги хранятся, пока ваш аккаунт активен, и стираются, когда вы удаляете аккаунт. Кроме того, чаты Telegram удаляются через 30 дней после отключения." },
      ],
    },
    footer: {
      tagline: "Каждый клиент получит ответ. OctoMail отвечает на заявки в почте и Telegram, пока вы на объекте.",
      socialAria: (label: string) => `OctoAIverse в ${label}`,
      product: "Продукт",
      industries: "Сферы",
      answers: "Ответы",
      company: "Компания",
      links: {
        contractors: "Строительство и ремонт",
        dealerships: "Автосалоны",
        dental: "Стоматологии",
        auto: "Автосервисы",
        rv: "Дома на колёсах",
        sales: "Отделы продаж",
        speedToLead: "Что такое скорость ответа",
        howFast: "Как быстро отвечать",
        vsReceptionist: "OctoMail или секретарь",
        canAi: "Может ли ИИ отвечать на почту",
        contact: "Контакты",
        privacy: "Конфиденциальность",
        terms: "Условия",
      },
      copyrightA: (year: number) => `© ${year} OctoMail от `,
      copyrightB: ". Все права защищены.",
    },
  },
  app: {
    loading: "Загрузка",
    nav: { home: "Главная", leads: "Заявки", questions: "Вопросы", settings: "Настройки", help: "Помощь" },
    shell: { account: "Аккаунт", signOut: "Выйти", copyright: (year: number) => `© ${year} OctoMail от OctoAIverse` },
    fmt: { justNow: "только что", minAgo: (m: number) => `${m} мин назад`, hrAgo: (h: number) => `${h} ч назад`, dayAgo: (d: number) => `${d} дн назад`, today: "Сегодня", yesterday: "Вчера", generic: "Что-то пошло не так." },
    status: { qualified: "Целевая", needsInfo: "Нужны детали", unqualified: "Не целевая", held: "Ожидает", pending: "В очереди" },
    filters: { filters: "Фильтры", status: "Статус", all: "Все", qualified: "Целевые", needsInfo: "Нужны детали", category: "Категория", clearAll: "Сбросить" },
    thread: {
      noHistory: "Истории переписки пока нет. Возможно, заявка была отобрана до включения отслеживания сообщений.",
      reply: "Ответ", edit: "Изменить", preview: "Предпросмотр", copied: "Скопировано!", copy: "Копировать",
      placeholder: "Отредактируйте черновик ИИ и нажмите Отправить, или напишите свой…", replyAria: "Текст ответа",
      closedNote: "Заявка закрыта. Откройте её снова ниже, чтобы отправить ещё один ответ.",
      supportsA: "Поддерживает", bold: "**жирный**", italic: "*курсив*", supportsB: ", списки и ссылки. Клиент получит аккуратное, отформатированное письмо.",
      sending: "Отправляем…", sendTo: (name: string) => `Отправить: ${name}`, resetDraft: "Вернуть черновик ИИ",
      replyWindow: (h: number, m: number) => `Telegram позволяет ответить здесь еще ${h} ч ${m} мин.`,
      windowClosed: "Telegram закрыл этот чат для OctoMail (24 часа без сообщений клиента). Ответьте в Telegram.",
      openInTelegram: "Открыть в Telegram",
      telegramHint: "Отправляется с вашего аккаунта Telegram обычным сообщением. Форматирование убирается.",
      sendErrors: {
        reply_window_closed: "Telegram закрыл этот чат для OctoMail (24 часа без сообщений клиента). Ответьте в Telegram.",
        telegram_not_connected: "Telegram не подключен. Подключите его заново в Настройках.",
        telegram_cannot_reply: "Telegram не разрешает OctoMail отвечать. В Telegram: Настройки > Telegram для бизнеса > Чат-боты, включите ответы в управлении сообщениями.",
        send_failed: "Telegram не принял это сообщение. Попробуйте еще раз или ответьте в Telegram.",
        subscription_required: "Для ответа нужен активный тариф или пробный период OctoMail. Проверьте раздел Тариф и оплата в Настройках.",
        body_too_long: "Сообщение слишком длинное для Telegram (не больше 4096 символов).",
        body_required: "Сначала напишите сообщение.",
      },
    },
    msg: { sentOnYourBehalf: "отправлено от вашего имени", openInGmail: "Открыть в Gmail →" },
    questions: {
      title: "Вопросы", subtitle: "Что делает заявку стоящей вашего времени. OctoMail ищет это в каждом запросе.",
      add: "Добавить вопрос", loadingAria: "Загрузка вопросов",
      emptyTitle: "Расскажите OctoMail, какая заявка хорошая",
      emptyBody: "OctoMail проверяет каждый входящий запрос по этим вопросам. Если обязательных ответов нет, он помечает заявку или сам уточняет.",
      adding: "Добавляем…", starterPack: "Стартовый набор из 6 вопросов", scratch: "Начать с нуля", saveChanges: "Сохранить",
      moveUp: "Выше", moveDown: "Ниже", edit: "Изменить", editQuestion: "Изменить вопрос", delete: "Удалить", deleteQuestion: "Удалить вопрос",
      required: "Обязательный", optional: "Необязательный",
      kinds: { text: "Текст", select: "Выбор", number: "Число", boolean: "Да / Нет" },
      confirmDelete: "Удалить этот вопрос? Это нельзя отменить.", failDelete: "Не удалось удалить.", failReorder: "Не удалось изменить порядок.", failSeed: "Не удалось добавить шаблоны.",
      editor: {
        labelLabel: "Текст вопроса", labelPlaceholder: "например, Какой адрес объекта?", kindLabel: "Тип ответа",
        hints: { text: "Свободный ответ (например, адрес, заметки)", select: "Один вариант из списка (например, диапазон бюджета)", number: "Числовое значение (например, площадь)", boolean: "Один вопрос да или нет" },
        requiredLabel: "Обязателен для отбора", optionsLabel: "Варианты", optionsHint: "(по одному в строке)",
        optionsPlaceholder: "До 5 млн сумов\nОт 5 до 25 млн сумов\nОт 25 до 100 млн сумов\nБолее 100 млн сумов",
        optionsNote: "Минимум 2 варианта. Ответ клиента должен совпасть с одним из них (без учёта регистра), чтобы считаться действительным.",
        errLabelRequired: "Введите текст вопроса.", errLabelLong: "Текст вопроса не длиннее 200 символов.", errOptions: "Вопросу с выбором нужно минимум 2 варианта.",
        failSave: "Не удалось сохранить.", saving: "Сохраняем…", cancel: "Отмена",
      },
    },
    starter: [
      { label: "Какой это проект?", options: ["Ремонт кухни", "Ремонт ванной", "Подвал / пристройка", "Фасад / кровля", "Другое"] },
      { label: "Какой адрес объекта?" },
      { label: "Какой диапазон бюджета?", options: ["До 5 млн сумов", "От 5 до 25 млн сумов", "От 25 до 100 млн сумов", "Более 100 млн сумов"] },
      { label: "К какому сроку нужно закончить?" },
      { label: "Есть ли готовые чертежи или замеры?" },
      { label: "Как с вами удобнее связаться?", options: ["Электронная почта", "Телефон", "SMS"] },
    ],
    settings: {
      title: "Настройки", subtitle: "Личные настройки. Они не покидают ваш аккаунт.",
      billing: {
        name: "Тариф и оплата", hint: "Подписка, пробный период и платёжные данные.", loading: "Загрузка…",
        activeRenews: (d: string) => `Активна, продление ${d}`, trialLeft: (n: number) => `Пробный период, осталось ${n} дн.`, pastDue: "Платёж не прошёл, обновите карту", canceled: "Отменена", noPlan: "Нет активного тарифа",
        active: "Активна", trialChip: (n: number) => `Пробный период · ${n} дн.`, paymentFailed: "Платёж не прошёл",
        subscribed: "Вы подписаны. Спасибо!", cancelled: "Оплата отменена. Деньги не списаны.",
        perMonth: "мес", perYear: "год", annualNote: "Три месяца бесплатно по сравнению с помесячной.", monthlyNote: "Отмена в любой момент. Два клика, без препятствий.",
        monthly: "Помесячно", annual: "За год",
        features: ["Безлимит входящих заявок", "Ответы ИИ вашими словами", "Автопилот с контролем утверждения", "Ежедневная сводка и список заявок"],
        redirecting: "Перенаправляем…", subscribe: "Подписаться", loadingPortal: "Открываем портал…", manage: "Управлять оплатой",
      },
      autopilot: {
        name: "Автопилот", hint: "OctoMail отвечает на новые заявки автоматически, вашими словами. Он никогда сам не называет цену и не обещает дату.",
        title: "Автоматические ответы на новые заявки", body: "Самый первый ответ вы утверждаете, чтобы оценить качество. Дальше он работает сам.",
        on: "Включён. Новые заявки получают автоматический ответ.", off: "Выключен. Вы проверяете и отправляете каждый ответ сами.", failed: "Не удалось обновить автопилот.",
      },
      cc: {
        name: "Копия ответов", hint: "Отправлять копию каждого ответа OctoMail на второй адрес (ассистенту или партнёру).", legend: "Копия ответов",
        secondary: "Дополнительная почта", placeholder: "assistent@kompaniya.uz", ccLabel: "Ставить этот адрес в копию каждого ответа", ccHint: "Получатели увидят адрес в копии.",
        errNeedEmail: "Добавьте дополнительную почту или выключите копию.", errInvalid: "Это не похоже на корректную почту.", failSave: "Не удалось сохранить.",
        saving: "Сохраняем…", save: "Сохранить настройки", saved: "Сохранено ✓",
      },
      telegram: {
        name: "Telegram",
        hint: "OctoMail будет отвечать клиентам, которые пишут вам в Telegram. Нужен Telegram Premium.",
        consentTitle: "Перед подключением",
        consentBody: [
          "OctoMail читает только те чаты, которые вы откроете ему в Telegram (Настройки > Telegram для бизнеса > Чат-боты).",
          "Текст сообщений из этих чатов отправляется в Google Gemini, чтобы понять их и написать ответ.",
          "Мы храним эти чаты, пока ваш аккаунт активен. Вы можете в любой момент удалить аккаунт, и тогда всё будет стёрто, а чаты Telegram удаляются через 30 дней после отключения.",
          "OctoMail никогда не называет цены и не обещает сроки и перестает отвечать в чате, где вы ответили сами.",
        ],
        consentCheck: "Согласен",
        connect: "Подключить Telegram",
        connecting: "Открываем Telegram…",
        waiting: "Нажмите Start в Telegram и следуйте шагам бота. Страница обновится сама.",
        linkedNotConnected: "Привязано. Последний шаг в Telegram: Настройки > Telegram для бизнеса > Чат-боты > добавьте @OctoAIversebot.",
        connected: (u: string) => `Подключено${u ? ` (@${u})` : ""}. Новые клиенты получают автоматический ответ.`,
        cannotReply: "Telegram не разрешает OctoMail отвечать. В Telegram: Настройки > Telegram для бизнеса > Чат-боты, включите ответы в управлении сообщениями.",
        deleteAllWarning: "Совет: в разделе Чат-боты отключите \"удаление всех сообщений\" в управлении сообщениями. OctoMail это не нужно.",
        setupTips: [
          "Выберите \"Все личные чаты, кроме...\" и исключите \"Контакты\", чтобы переписка с близкими осталась личной.",
          "Клиенты по-прежнему пишут ВАМ, а не боту.",
        ],
        usage: (n: number, max: number) => `${n} из ${max} диалогов с ИИ в этом месяце`,
        failed: "Не удалось начать подключение Telegram.",
        startOver: "Начать заново",
        reloadPage: "OctoMail обновился. Перезагрузите страницу и попробуйте снова.",
        needsSubscription: "Для Telegram нужен активный тариф или пробный период OctoMail. Проверьте раздел Тариф и оплата в Настройках.",
      },
      more: {
        name: "Ещё от OctoAIverse", hint: "Сообщения под контролем. А телефонная линия?", product: "OctoReception", tagline: "Каждый звонок, отвечен.",
        body: "ИИ-секретарь, который отвечает на ваш рабочий номер 24/7: отвечает на вопросы, записывает на приём и присылает вам краткую сводку сразу после звонка.",
        cta: "Бесплатный тестовый звонок →", price: "От 24,95 USD/мес · карта для теста не нужна",
      },
      danger: {
        name: "Опасная зона", hint: "Навсегда удалить аккаунт, данные и доступ OctoMail к вашей почте.",
        body1A: "Удаление аккаунта OctoMail стирает всё, что здесь хранится (заявки, историю сообщений, настройки), отменяет активную подписку и отключает OctoMail от вашей почты.", body1B: "Это нельзя отменить.",
        body2: "Сами аккаунты не затрагиваются: ваши Gmail и Telegram остаются как есть, и каждое сообщение, включая ответы, отправленные OctoMail от вашего имени, остаётся на месте. Мы просто теряем доступ.",
        delete: "Удалить аккаунт", confirm: "Вы уверены? Это навсегда сотрёт всё и не подлежит отмене.", deleting: "Удаляем…", yes: "Да, удалить всё", cancel: "Отмена",
        fail: "Не удалось удалить аккаунт. Попробуйте снова.",
      },
    },
    help: {
      title: "Помощь и поддержка", subtitle: "Что-то не получается? Поможет живой человек.", talk: "Написать человеку", sameDay: "Обычно отвечаем в тот же день.", emailSupport: "Написать в поддержку",
      cantFindA: "Не нашли, что искали? Напишите на", cantFindB: ", каждое письмо читает живой человек.",
      sections: [
        { title: "Начало работы", faqs: [
          { q: "Как быстро OctoMail отвечает на новую заявку?", a: "OctoMail читает новый запрос через секунды после его появления в почте и сразу готовит ответ. С включённым автопилотом он отправляется автоматически, обычно в течение минуты, задолго до того, как конкурент вообще откроет письмо." },
          { q: "Нужна ли техническая настройка?", a: "Нет. Вы один раз входите через Google или по email, подключаете Gmail или Telegram, остальное делает OctoMail: без правил пересылки, без айтишников, ничего устанавливать не нужно. Умеете проверять сообщения, значит справитесь." },
          { q: "Можно ли пользоваться OctoMail только с Telegram?", a: "Да. При настройке подключите Telegram вместо Gmail (нужен Telegram Premium). Gmail можно добавить позже на Главной в любой момент." },
          { q: "Как он решает, какая заявка хорошая?", a: "Читает каждое письмо через то, что важно вам (кто пишет, что нужно, сроки, адрес), помечает настоящие заявки и откладывает спам и просто интересующихся. Это настраивается в любой момент на странице Вопросы." },
          { q: "А если в заявке недостаточно информации?", a: "OctoMail помечает заявку как «нужны детали» и готовит дружелюбный ответ, который спрашивает только недостающее, чтобы разговор продолжался без вашего участия." },
        ] },
        { title: "Ответы и автопилот", faqs: [
          { q: "Он отправит письма без меня?", a: "Только если вы этого хотите. Самый первый ответ вы утверждаете, чтобы услышать, как он звучит. Дальше автопилот отправляет автоматически, и вы в любой момент можете выключить его в Настройках, чтобы проверять каждый ответ сами." },
          { q: "Он назовёт цену или пообещает дату?", a: "Нет. Ответы устроены так, чтобы никогда не обещать цену, дату или объём, который вы не задавали. Он располагает клиента и передаёт детали вам." },
          { q: "Могут ли ответы ставить в копию ассистента или партнёра?", a: "Да. Укажите дополнительный адрес в Настройки → Копия ответов, и каждый ответ OctoMail будет уходить и ему." },
        ] },
        { title: "Оплата", faqs: [
          { q: "Как работает бесплатный период?", a: "Каждый новый аккаунт начинается с 7 бесплатных дней: полный продукт, карта не нужна. Подпишитесь в приложении, когда будете готовы; до этого ничего не спишется." },
          { q: "Как отменить?", a: "Два клика в Настройки → Управлять оплатой, или напишите на support@octoaiverse.com, и мы всё сделаем. Без препятствий и уговоров." },
          { q: "В какой валюте списывается оплата?", a: "Клиенты из Канады платят в CAD, все остальные в USD. Цена в приложении и есть цена, которую вы платите." },
        ] },
        { title: "Конфиденциальность и безопасность", faqs: [
          { q: "Моя почта в безопасности?", a: "Да. Мы подключаемся через официальный защищённый вход Google, ваш пароль никогда не попадает в OctoMail. Данные почтового ящика хранятся в зашифрованном виде, письма никому не передаются и не продаются." },
          { q: "Могу ли я отключить почту?", a: "В любой момент. Отключение в Настройках сразу прекращает весь доступ. Удаление аккаунта также убирает OctoMail из подключённых приложений вашего аккаунта Google." },
          { q: "OctoMail изменяет или удаляет мои письма?", a: "Никогда. Он только читает новые входящие, чтобы находить заявки, и отправляет утверждённые вами ответы. Он не может помечать, архивировать, изменять или удалять что-либо." },
        ] },
      ],
    },
    paywall: {
      title: "Бесплатный период закончился", sub: "Подпишитесь, чтобы OctoMail продолжал собирать сообщения из почты и Telegram и отвечать на заявки.",
      held: (n: number) => `${n} ${plural(n, "заявка пришла", "заявки пришли", "заявок пришло")}, пока пробный период был на паузе`,
      heldNote: (n: number) => n === 1 ? "Она ещё не прочитана и не получила ответ. Подпишитесь, и OctoMail сразу её отберёт." : "Они ещё не прочитаны и не получили ответ. Подпишитесь, и OctoMail сразу их отберёт.",
      monthly: "Помесячно", annual: "За год", save25: "экономия 25%", redirecting: "Перенаправляем…", subscribe: "Подписаться и сохранить заявки", signOut: "Выйти",
    },
    trial: {
      daysLeft: (n: number) => `${n} ${plural(n, "день", "дня", "дней")} до конца бесплатного периода`,
      endsToday: "Бесплатный период заканчивается сегодня",
    },
    home: {
      srTitle: "Главная: ваша ежедневная сводка",
      declined: "Вы отклонили доступ. Без доступа к почте OctoMail не может читать запросы.",
      tryAgain: "Попробовать снова",
      noRefreshA: "Google не вернул токен обновления. Отключите это приложение в",
      noRefreshLink: "разрешениях аккаунта Google",
      noRefreshB: "и попробуйте снова.",
      connectError: "Не удалось подключить почту. Попробуйте снова.",
      gmailConnected: (email: string) => `Gmail подключён · ${email}`,
      gettingSetUp: "Настройка",
      needsYou: "Ждут вас",
      caughtUp: "Всё разобрано.",
      statNew: "Новые заявки",
      statReplied: "Отвечено",
      statNeeds: "Ждут вас",
      last7: "Заявки · последние 7 дней",
      today: "Сегодня",
      howItWorks: "Как это работает",
      handledBy: "Обработал автопилот",
      pipelineIntro: "Вот что теперь происходит с каждым письмом:",
      pipelineIntroTelegram: "Вот что теперь происходит с каждым новым сообщением:",
      noRepliesYet: "Ответов пока нет.",
      viewAllHandled: "Все обработанные заявки →",
      viewAllNeeds: (n: number) => `Все ${n} в разделе «Заявки» →`,
      savedA: (mins: number) => `~${mins} ${plural(mins, "минута", "минуты", "минут")}`,
      savedB: " сэкономлено на ответах за неделю.",
      outcomes: "Результаты ответов",
      days30: "30 дней",
      writeBack: (pct: number) => `${pct}% заявок отвечают`,
      responded: "Ответили",
      waiting: "Ждём",
      cold: "Остыли",
      ofWroteBack: (r: number, s: number) => `${r} из ${s} ответили`,
      coldNote: "Заявка считается остывшей после 3 дней без ответа.",
      comingSoon: "Скоро",
      roadmap: ["Outlook и Microsoft 365", "Календарь для записанных заказов", "Несколько почтовых ящиков"],
      newLead: "Новая заявка",
      channels: {
        aria: "Подключённые каналы",
        gmail: "Gmail",
        telegram: "Telegram",
        email: "Эл. почта",
        connectGmail: "Подключить Gmail",
        reconnectGmail: "Переподключить Gmail",
        connectTelegram: "Подключить Telegram",
        telegramRepliesOff: "Telegram: ответы выключены",
        telegramFinish: "Telegram: завершите настройку",
      },
      reasons: {
        complaint: "Жалоба",
        existingCustomer: "Текущий клиент",
        media: "Голосовое или файл",
        aiPaused: "ИИ на паузе",
        replySoon: "Ответьте скорее",
        draftReady: "Черновик готов",
        queued: "В очереди",
        open: "Открыта",
      },
      lead: "Заявка",
      replied: "Отвечено",
      leadCount: (n: number) => `${n} ${plural(n, "заявка", "заявки", "заявок")}`,
      autopilotRepliedIn: (speed: string) => `Автопилот ответил через ${speed} после получения заявки`,
      there: "друг",
      dow: ["В", "П", "В", "С", "Ч", "П", "С"],
      brief: {
        morning: "Доброе утро",
        afternoon: "Добрый день",
        evening: "Добрый вечер",
        quiet: "Пока тихо, ничего не требует вашего внимания. Новые заявки появятся здесь, как только придут.",
        repliedWeek: (n: number) => `Вы и автопилот ответили на ${n} ${plural(n, "заявку", "заявки", "заявок")} за неделю.`,
        noReplies: "На этой неделе ответов пока не было.",
        nothingNeeds: "Сейчас ничего не требует вашего внимания.",
        waitingOnYou: (n: number) => `${n} ${plural(n, "заявка ждёт", "заявки ждут", "заявок ждут")} вас.`,
      },
      clock: { yourAssistant: "Ваш ассистент", eyebrow: "Ежедневная сводка", live: "● онлайн", currentTime: (t: string) => `Текущее время ${t}` },
      firstRun: {
        pipeline: [
          { title: "Клиент пишет вам", sub: "Любой запрос, попавший в вашу почту." },
          { title: "OctoMail читает и оценивает", sub: "Настоящие покупатели внутрь, спам в сторону." },
          { title: "Ответ готовится вашими словами", sub: "Тёплый, личный, без выдуманных цен." },
          { title: "Первый ответ утверждаете вы", sub: "Дальше всё делает автопилот." },
        ],
        pipelineTelegramFirst: { title: "Клиент пишет вам", sub: "Любой новый чат в вашем Telegram." },
        pipelineTelegramLast: { title: "Отвечает сразу", sub: "Только в разрешённых вами чатах и умолкает, как только вы ответите сами." },
        connectLabel: "Подключите Gmail",
        connectSub: "Готово. OctoMail следит за вашей почтой.",
        tuneLabel: "Настройте вопросы для отбора",
        tuneSub: "Расскажите, какая заявка хороша для вашего бизнеса.",
        tuneCta: "Посмотреть вопросы",
        testLabel: "Отправьте себе тестовую заявку",
        testSub: "Напишите на свою почту запрос цены и посмотрите, как он будет отобран.",
        testCta: "Отправить тестовое письмо",
        tgConnectLabel: "Подключите Telegram",
        tgConnectSub: "Готово. OctoMail отвечает новым клиентам в Telegram.",
        tgFinishLabel: "Завершите настройку Telegram",
        tgFinishCta: "Открыть настройки Telegram",
        tgTestLabel: "Отправьте тестовое сообщение",
        tgTestSub: "Попросите человека, которого нет в ваших контактах, написать вам в Telegram, и посмотрите, как ответит OctoMail.",
        testSubject: "Запрос цены: ремонт кухни",
        testBody: "Здравствуйте! Планируем ремонт кухни этой осенью и собираем цены на этой неделе. Бюджет около 30 миллионов сумов, хотели бы начать в октябре. Сможете прислать примерную смету и ваши свободные даты?\n\nСпасибо,\nА. Клиент",
      },
    },
    leads: {
      title: "Заявки",
      subtitle: "Каждый входящий запрос, оценённый по вашим вопросам.",
      loadingAria: "Загрузка заявок",
      noLeadsYet: "Заявок пока нет",
      noLeadsBody: "Они появятся здесь автоматически по мере поступления писем.",
      noOpen: "Открытых заявок нет. Всё разобрано.",
      noSnoozed: "Отложенных сейчас нет.",
      noDone: "Завершённых заявок пока нет.",
      noFiltered: "Отфильтрованных пока нет.",
      noMatch: "Под этот фильтр заявок нет.",
      notLeadBody: "Рассылки, чеки и уведомления попадают сюда, а не ваши настоящие заявки.",
      tryAdjust: "Попробуйте изменить поиск, статус или фильтры категорий выше.",
      firstRun: {
        eyebrow: "Ждём вашу первую заявку",
        title: "Ваши заявки будут появляться здесь, уже прочитанные, оценённые и с ответом.",
        watchingA: "OctoMail следит за",
        yourInbox: "вашей почтой",
        yourTelegram: "вашими чатами в Telegram",
        andTelegram: " и вашими чатами в Telegram",
        yourChannels: "вашими подключёнными каналами",
        watchingB: ". Как только придёт запрос, он появится в этом списке со всем извлечённым: кто пишет, что нужно и подготовленный ответ.",
        sendTest: "Отправьте себе тестовую заявку",
        reviewQuestions: "Посмотреть вопросы",
        testNote: "Тестовое письмо приходит как обычный запрос и отбирается примерно за минуту.",
        pipelineEyebrow: "Что происходит с каждым письмом",
        pipelineEyebrowMessages: "Что происходит с каждым сообщением",
      },
      buckets: { attention: "Требуют внимания", open: "Открытые", snoozed: "Отложенные", done: "Готово", notlead: "Не заявки" },
      noAttention: "Сейчас ничего не требует вашего личного внимания.",
      attentionBody: "Сюда попадают жалобы и сообщения текущих клиентов. OctoMail никогда не отвечает на них автоматически.",
      attentionKind: { complaint: "Жалоба", existing_customer: "Текущий клиент" },
      attentionBanner: "Похоже, это сообщение требует вашего личного ответа. OctoMail не стал отвечать автоматически, поэтому проверьте черновик перед отправкой.",
      pendingBanner: "OctoMail сохранил это письмо, но пока не смог его прочитать. Он пробует снова каждые 30 минут.",
      bucketAria: "Раздел заявок",
      searchPlaceholder: "Поиск заявок…",
      searchAria: "Поиск заявок",
      attachments: (n: number) => `${n} ${plural(n, "вложение", "вложения", "вложений")}`,
      replied: "Отвечено",
      telegramBadge: "Telegram",
      mediaChip: "Голосовое или файл",
      aiPausedCap: "ИИ на паузе: лимит этого месяца исчерпан. Ответьте сами; лимит обновится 1-го числа.",
      aiPausedDaily: "ИИ на паузе до завтра: дневной лимит безопасности.",
      panel: {
        back: "‹ Заявки",
        close: "Закрыть",
        noQuestionsA: "Добавьте вопросы для отбора, и OctoMail будет извлекать ответы (бюджет, сроки, адрес) из каждой заявки.",
        setThemUp: "Настроить →",
        notProvided: "не указано",
        snooze: "Отложить",
        s1d: "1 д",
        s3d: "3 д",
        s1wk: "1 нед",
        notInterested: "Не интересно",
        unsnoozeUntil: (d: string) => `Вернуть (до ${d})`,
        reopen: "Открыть снова",
      },
    },
    login: {
      homeAria: "На главную страницу OctoMail",
      welcomeBack: "С возвращением",
      createAccount: "Создайте аккаунт",
      signInSub: "Войдите в OctoMail, чтобы управлять заявками.",
      signUpSub: "Начните отбирать заявки за несколько минут.",
      redirecting: "Перенаправляем…",
      continueGoogle: "Продолжить с Google",
      oneTap: "Одно касание подключает и вашу почту, без второго шага.",
      reviewA: "Google завершает проверку OctoMail, поэтому на следующем экране может появиться предупреждение. Выберите",
      reviewAdvanced: "Advanced → Go to OctoMail",
      reviewB: ", чтобы продолжить. Ваши данные остаются приватными и защищёнными.",
      or: "или",
      email: "Электронная почта",
      emailPlaceholder: "vy@kompaniya.uz",
      password: "Пароль",
      loading: "Загрузка…",
      signIn: "Войти",
      createAccountBtn: "Создать аккаунт",
      newTo: "Впервые в OctoMail?",
      createAnAccount: "Создать аккаунт",
      already: "Уже есть аккаунт?",
      agreeA: "Продолжая, вы принимаете наши",
      terms: "Условия",
      and: "и",
      privacy: "Политику конфиденциальности",
      agreeB: ".",
      errors: {
        badCredential: "Неверная почта или пароль.",
        emailInUse: "Аккаунт с такой почтой уже существует.",
        weakPassword: "Пароль должен быть не короче 8 символов.",
        cancelled: "Вход отменён.",
        network: "Ошибка сети. Проверьте подключение и попробуйте снова.",
        generic: "Что-то пошло не так.",
      },
    },
    onboarding: {
      title: "Давайте всё настроим",
      subtitle: "Три быстрых шага, и OctoMail начнёт работать на вас.",
      stepOf: (n: number, total: number) => `Шаг ${n} из ${total}`,
      s1Title: "Подключите каналы",
      s1Body: "Выберите, где вам пишут клиенты. Для начала хватит одного канала, второй можно добавить в любой момент.",
      gmailBody: "OctoMail читает входящие запросы, чтобы сортировать их и отвечать. Ваш пароль не покидает Google.",
      channelDone: "Подключено",
      channelsLabel: "Каналы",
      repliesOff: "Ответы выключены",
      s1Busy: "Открываем Google…",
      s1Btn: "Подключить Gmail",
      s2Title: "Выберите, что делает заявку хорошей",
      s2Body: "Начнём с 6 типичных вопросов (тип проекта, адрес, бюджет, сроки…). Их можно изменить в любой момент.",
      s2Busy: "Добавляем…",
      s2Btn: "Использовать стартовый набор",
      s2Manual: "Настроить вручную",
      s3Title: "Всё готово",
      s3TitleAlmost: "Почти готово",
      s3Body: "OctoMail теперь следит за вашей почтой. Новые запросы будут появляться как заявки автоматически.",
      s3BodyTelegram: "OctoMail теперь следит за вашими чатами в Telegram. Новые сообщения будут появляться как заявки автоматически.",
      s3BodyBoth: "OctoMail теперь следит за вашей почтой и чатами в Telegram. Новые запросы будут появляться как заявки автоматически.",
      s3Btn: "К моим заявкам",
    },
  },
  meta: {
    title: "OctoMail: каждый клиент получит ответ",
    description: "OctoMail читает каждое новое письмо и сообщение в Telegram, в течение минуты отвечает вашим тоном на языке клиента и передаёт вам настоящих покупателей. 7 дней бесплатно.",
    ogDescription: "Читает каждое новое письмо и сообщение в Telegram, в течение минуты отвечает и передаёт вам настоящих покупателей.",
    ogImageAlt: "OctoMail: каждый клиент получит ответ.",
  },
};
